<div class="whatsapp-device-panel">
  <div *ngIf="loading && !device" class="panel-loading">
    <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
    <span class="ms-2">Loading device...</span>
  </div>
  <div *ngIf="loadError && !device" class="panel-error text-danger small mb-2">
    {{ loadError }}
  </div>
  <div *ngIf="showEmptyState" class="panel-empty">
    <p class="text-muted mb-2">No WhatsApp device connected.</p>
    <button type="button" class="btn btn-primary btn-sm" (click)="onAddDevice()" *ngIf="!readOnly">Add Device</button>
  </div>
  <div *ngIf="device" class="panel-card">
    <div class="card-title">WhatsApp Device</div>
    <div class="card-row">
      <span class="label">Phone:</span>
      <span class="value">{{ device.phone || '—' }}</span>
    </div>
    <div class="card-row">
      <span class="label">Instance ID:</span>
      <span class="value text-truncate" [title]="device.instanceId || ''">{{ device.instanceId || '—' }}</span>
    </div>
    <div class="card-row">
      <span class="label">Status:</span>
      <span class="badge" [class.bg-success]="isConnected" [class.bg-secondary]="!isConnected">
        {{ statusLabel }}
      </span>
    </div>
    <div *ngIf="!readOnly" class="card-actions">
      <button
        type="button"
        class="btn btn-outline-primary btn-sm"
        (click)="onReconnect()"
        [disabled]="isConnected"
      >
        {{ isConnected ? 'Connected' : 'Reconnect' }}
      </button>
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm"
        (click)="onLogout()"
        [disabled]="loading || !isConnected"
      >
        Logout
      </button>
      <button
        type="button"
        class="btn btn-outline-danger btn-sm"
        (click)="onRemove()"
        [disabled]="removing"
      >
        {{ removing ? 'Removing...' : 'Remove' }}
      </button>
    </div>
  </div>
</div>

<app-modal
  *ngIf="qrModalTemplate"
  [state]="showQrModal"
  [template]="qrModalTemplate"
  [size]="qrModalSize"
></app-modal>

<ng-template #qrModalHeader>
  <div class="d-flex align-items-center justify-content-between w-100">
    <h5 class="mb-0">Scan QR Code</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeQrModal()"></button>
  </div>
</ng-template>
<ng-template #qrModalBody>
  <app-whatsapp-qr-modal
    [open]="showQrModal"
    [accountId]="qrModalAccountId"
    (connected)="onQrConnected($event)"
    (closed)="onQrClosed()"
  ></app-whatsapp-qr-modal>
</ng-template>
